<template>
  <div>
    <a-breadcrumb>
      <a-breadcrumb-item>系统设置</a-breadcrumb-item>
      <a-breadcrumb-item>角色权限</a-breadcrumb-item>
    </a-breadcrumb>
    <div class="space-20">
      <a-button size="small" type="primary" @click="showModel = 'addRole'">新增</a-button>
    </div>
    <a-table :loading="loading" :columns="columns" :dataSource="list" :rowKey="row => row.id" :pagination="pagination" @change="handleTableChange">
      <span slot="action" slot-scope="row">
        <a-button @click="handleOpenNewPage('/systemSetting/manage/rolePower/data?id=' + row.id + '&name=' + row.name)" size="small" type="primary"
          >数据权限</a-button
        >
        <a-divider type="vertical" />
        <a-button @click="handleOpenNewPage('/systemSetting/manage/rolePower/menu?id=' + row.id + '&name=' + row.name)" size="small">菜单权限</a-button>
        <a-divider type="vertical" />
        <a-button
          @click="
            currentRow = row;
            showModel = 'editRole';
          "
          size="small"
          type="primary"
          >编辑</a-button
        >
        <a-divider type="vertical" />
        <a-button @click="handleDeleteItem(row)" size="small" type="danger">删除</a-button>
      </span>
    </a-table>
    <a-modal title="新增角色" @cancel="closeModel" :visible="showModel == 'addRole'" width="400px">
      <a-form>
        <a-form-item label="角色名称：" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
          <a-input v-model="roleInfo.name" placeholder="角色名称"></a-input>
        </a-form-item>
        <a-form-item label="备注：" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
          <a-input v-model="roleInfo.description" placeholder="备注"></a-input>
        </a-form-item>
      </a-form>
      <template slot="footer">
        <a-button @click="closeModel">取消</a-button>
        <a-button type="primary" @click="handleItem('add')">确定</a-button>
      </template>
    </a-modal>
    <a-modal title="编辑角色" @cancel="closeModel" :visible="showModel == 'editRole'" width="400px">
      <a-form>
        <a-form-item label="角色名称：" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
          <a-input v-model="currentRow.name" placeholder="阶段名称"></a-input>
        </a-form-item>
        <a-form-item label="备注：" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
          <a-input v-model="currentRow.description" placeholder="备注"></a-input>
        </a-form-item>
      </a-form>
      <template slot="footer">
        <a-button @click="closeModel">取消</a-button>
        <a-button type="primary" @click="handleItem('edit')">确定</a-button>
      </template>
    </a-modal>
  </div>
</template>
<script>
import { roleList, roleAction, roleDelete } from '@/api/systemRoleSetting.js';
const columns = [
  { title: '角色名称', dataIndex: 'name' },
  { title: '备注', dataIndex: 'description', align: 'center' },
  { title: '操作', align: 'center', scopedSlots: { customRender: 'action' } }
];
export default {
  data() {
    return {
      loading: true,
      columns,
      list: [],
      pagination: { total: 0, page: 1, pageSize: 100 },
      currentRow: {},
      showModel: '',
      roleInfo: {
        name: '',
        description: ''
      }
    };
  },
  methods: {
    handleOpenNewPage(url) {
      window.open(window.location.origin + url);
    },
    closeModel() {
      this.showModel = '';
    },
    handleTableChange(pagination) {
      this.pagination.page = pagination.current;
      this.getList();
    },
    getList() {
      this.loading = true;
      roleList(this.pagination).then(res => {
        this.list = res.data.list;
        this.pagination.total = res.data.total;
        this.pagination.page = res.data.page;
        this.loading = false;
      });
    },
    handleDeleteItem(row) {
      this.$confirm({
        title: `确定删除角色：${row.name}吗`,
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk: () => {
          roleDelete({ roleId: row.id }).then(res => {
            if (res.code === 200) {
              this.$message.success(res.data);
              this.getList();
            }
          });
        }
      });
    },
    handleItem(type) {
      let data = Object.assign({}, this.roleInfo);
      if (type === 'edit') {
        data.name = this.currentRow.name;
        data.description = this.currentRow.description;
        data.id = this.currentRow.id;
      }
      roleAction(data).then(res => {
        if (res.code === 200) {
          this.closeModel();
          this.getList();
          this.$message.success(res.data || 'success');
          !data.id && (this.roleInfo = { name: '', description: '' });
        }
      });
    }
  },
  mounted() {
    this.getList();
  }
};
</script>
